/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_EnhanceInputs */

const cs_property_ai_enhance = /** @type {(inputs: Property_Ai_EnhanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vylepšit`)
};

const en_property_ai_enhance = /** @type {(inputs: Property_Ai_EnhanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enhance`)
};

/**
* | output |
* | --- |
* | "Enhance" |
*
* @param {Property_Ai_EnhanceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_enhance = /** @type {((inputs?: Property_Ai_EnhanceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_EnhanceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_enhance(inputs)
	return cs_property_ai_enhance(inputs)
});